import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import PublicRoutes from './routes/routes';
import { RouteShimmer } from './components/shared/shimmer';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<RouteShimmer />}>
          <PublicRoutes />
        </Suspense>
      </PersistGate>
    </Provider>
  );
};

export default App;
